<template minapp='mpx' xlang='wxml'>
  <es-drawer-bottom title="候补详情" show="{{show}}" showDefaultNav bind:close="close" class="main">
    <view class="container">
      <view wx:if="{{!alternateDetail}}" class="ing">
        <image
          class="icon"
          mode="aspectFit"
          src="https://ut-static.udache.com/webx/sfc/ACScjhChZf03BjcvLsvju_clipboard_image_1697684792317.png"
        ></image>
        <view class="tip">正在全力提交候补中...</view>
        <view bindtap="scanDualDesc" class="btn">12306候补规则</view>
      </view>
      <view class="done" wx:else>
        <view bindtap="scanDualDesc" class="title"
          >以下候补车次已提交<image
            class="icon"
            mode="aspectFit"
            src="https://ut-static.udache.com/webx/sfc/XNKxsIYqRbUxR384Y6Kfa_clipboard_image_1697628299313.png"
        /></view>
        <view class="passenger">乘车人：{{ alternateDetail.passengers }}</view>
        <view wx:for="{{alternateDetail.candidatetrains}}" wx:key="index" class="train">
          <view class="flex-center">
            <view>{{ item.title }}</view>
            <view class="tip">{{ item.queue_desc }}</view>
          </view>
          <view class="flex-center info">
            <view class="station">
              <text>{{ item.from }}</text>
              <image
                class="icon"
                mode="aspectFit"
                src="https://ut-static.udache.com/webx/sfc/cwvShr2uyfoeHeC3Pl0sH_clipboard_image_1697705863596.png"
              ></image>
              <text>{{ item.to }}</text>
            </view>
            <view>{{ item.seat_name }}</view>
          </view>
        </view>
      </view>
    </view>
  </es-drawer-bottom>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import dayjs from 'dayjs'
  import { toScanDualDesc } from '@/common/pageJump'
  import store from '@/store'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
    },
    computed: {
      ...store.mapState({
        scrambleTicketInfo: 'order.scramble_ticket_info'
      }),
      alternateDetail() {
        const candidate = this.scrambleTicketInfo?.candidate
        if(!candidate) return null
        const candidatetrains = candidate.candidatetrains.map(train => {
          const {
            train_date,
            traincode,
            start_time,
            from_station_name,
            arrive_time,
            to_station_name
          } = train
          const title = `${dayjs(train_date).format('M月D日')} ${traincode}`
          const from = `${start_time} ${from_station_name}`
          const to = `${arrive_time} ${to_station_name}`
          return {
            title,
            from,
            to,
            ...train,
          }
        })
        return {
          ...candidate,
          candidatetrains,
          passengers: candidate.candidatepassengers?.join(' '),
        }
      }
    },
    methods: {
      close() {
        this.$trigger('close')
      },
      scanDualDesc() {
        this.close()
        toScanDualDesc()
      },
    }
  })
</script>

<style lang="stylus" scoped>
  .main
    /deep/ .header
      color #333
      line-height 1
      font-weight normal
      .drawer-title
        color #222
        font-family PingFangSC-Regular
        font-size 16px
    /deep/ .drawer-container
      height 355px
      overflow auto
    .container
      line-height 1
      font-weight normal
      .ing
        display flex
        flex-direction column
        align-items center
        .icon
          width 100px
          height 100px
          margin 6px 0 22px
        .tip
          font-family PingFangSC-Regular
          font-size 14px
          color #222222
        .btn
          margin-top 34px
          padding 17px 27px
          border 1px solid #ccc
          border-radius 10px
          font-family PingFangSC-Medium
          font-size 16px
          color #333
      .done
        display flex
        padding 0 16px
        flex-direction column
        align-items flex-start
        .title
          @extend .flex-center
          font-family PingFangSC-Medium
          font-size 18px
          color #000
          .icon
            width 18px
            height 18px
            margin-left 3px
        .passenger
          margin 8px 0 16px
          font-family PingFangSC-Regular
          font-size 14px
          color #666
        .train
          width 100%
          padding 16px 12px
          background #EAF3FF
          box-sizing border-box
          border 0.5px solid #8FC8E9
          border-radius 10px
          margin-bottom 8px
          font-family PingFangSC-Semibold
          font-size 19px
          color #222
          .flex-center
            @extend .flex-center
            justify-content space-between
            .tip
              font-family PingFangSC-Regular
              font-size 12px
              color #2F497D
              padding 5px 4px
              background #D2E6FF
              border-radius 3px
          .info
            font-family PingFangSC-Regular
            font-size 14px
            color #666666
            margin-top 14px
            .station
              @extend .flex-center
              .icon
                width 18px
                height 8px
                margin 4px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom'
    }
  }
</script>
